// https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories

import {
  AccountTermsInput,
  GetDocumentTemplatesInput,
  GetTagsInput,
  PaginationInput,
  UsersInput,
} from '@/gql/graphql';

const meKeys = {
  all: ['me'] as const,
  chatAgentConversations: () =>
    [...meKeys.all, 'chatAgentConversations'] as const,
  chatAgentConversation: (id: string) =>
    [...meKeys.all, 'chatAgentConversation', id] as const,
  account: () => [...meKeys.all, 'account'] as const,
  businessHours: () => [...meKeys.account(), 'businessHours'] as const,
  customFieldGroups: () => [...meKeys.account(), 'customFieldGroups'] as const,
  accountFeatures: () => [...meKeys.account(), 'features'] as const,
  canBulkExport: () => [...meKeys.all, 'canBulkExport'] as const,
  accountTimelogPreferences: () =>
    [...meKeys.account(), 'timelogPreferences'] as const,
  accountRegionPreferences: () =>
    [...meKeys.account(), 'regionPreferences'] as const,
  accountAvailableTags: (
    input?: GetTagsInput,
    pagination?: PaginationInput
  ) => {
    if (!pagination && !input) {
      return [...meKeys.account(), 'availableTags'] as const;
    }
    return [...meKeys.account(), 'availableTags', pagination, input] as const;
  },
  accountBranding: () => [...meKeys.account(), 'branding'] as const,
  accountAccountingIntegrations: () => {
    return [...meKeys.account(), 'accountingIntegrations'] as const;
  },
  integrations: () => [...meKeys.account(), 'integrations'] as const,
  accountAnalytics: () => [...meKeys.account(), 'analytics'] as const,
  accountSubdomain: () => [...meKeys.account(), 'subdomain'] as const,
  accountUsers: (input?: UsersInput) => {
    if (!input) {
      return [...meKeys.account(), 'accountUsers'] as const;
    }

    return [...meKeys.account(), 'accountUsers', input] as const;
  },
  accountGrants: () => [...meKeys.account(), 'grants'] as const,
  accountTaxRates: () => [...meKeys.account(), 'taxRates'] as const,
  accountCisDeductionRate: () =>
    [...meKeys.account(), 'cisDeductionRate'] as const,
  accountFieldServiceSettings: () =>
    [...meKeys.account(), 'fieldServiceSettings'] as const,
  accountTerms: (input?: AccountTermsInput) => {
    if (!input) {
      return [...meKeys.account(), 'terms'] as const;
    }

    return [...meKeys.account(), 'terms', input] as const;
  },
  accountSystemRoles: () => [...meKeys.account(), 'systemRoles'] as const,
  openApiKeys: () => [...meKeys.account(), 'openApiKeys'] as const,
  accountWebhooks: (pagination?: PaginationInput) => {
    if (!pagination) {
      return [...meKeys.account(), 'webhooks'] as const;
    }
    return [...meKeys.account(), 'webhooks', pagination] as const;
  },
  accountDocumentTemplates: (
    input?: GetDocumentTemplatesInput,
    pagination?: PaginationInput
  ) => {
    if (!pagination && !input) {
      return [...meKeys.account(), 'documentTemplates'] as const;
    }

    return [
      ...meKeys.account(),
      'documentTemplates',
      input,
      pagination,
    ] as const;
  },
  accountDocumentTemplate: (id: string) => {
    return [...meKeys.account(), 'documentTemplates', id] as const;
  },
  analyticsSettings: () => [...meKeys.account(), 'analyticsSettings'] as const,
  accountTimelogTypes: () => [...meKeys.account(), 'timelogTypes'] as const,
  accountPipelines: () => [...meKeys.account(), 'pipelines'] as const,
};

export default meKeys;
